module.exports = __webpack_public_path__ + "static/media/chambers2020.60f8b5d0.jpg";